import api from '@/services/api';
import { TPostPatchEquipmentType } from '@/services/equipments/equipments';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

const usePostEquipmentTypes = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const navigate = useNavigate();

  return useMutation({
    mutationKey: ['postEquipmentTypes'],
    mutationFn: (data: TPostPatchEquipmentType) => {
      return api.equipments.postEquipmentType(data);
    },
    onError: (error) => {
      const errorMessage = error.message;
      toast.error(t('toast.error', { errorMessage }));
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['equipmentTypes'] });
      toast.success(t('toast.categoryCreated'));
      navigate(-1);
    },
    retry: false
  });
};

export default usePostEquipmentTypes;
